import styled from 'styled-components'

interface ISheetHeaderStyledProps {}

export const SheetHeaderStyled = styled.div<ISheetHeaderStyledProps>`
  font-size: inherit;

  padding: ${(props) => props.theme.typography.pxToRem(20)}
    ${(props) => props.theme.typography.pxToRem(8)}
    ${(props) => props.theme.typography.pxToRem(12)}
    ${(props) => props.theme.typography.pxToRem(8)};
`

SheetHeaderStyled.displayName = 'SheetHeaderStyled'
